module.exports = __webpack_public_path__ + "media/images/Group 3-1c9ceaa961b9e89828c4e8ad2eb4d162.svg";